import { prisma, type Prisma, SessionTrackTranslation } from "client";

export const createSessionTrack = async (
  eventId: string,
  translations: SessionTrackTranslation[],
  color?: string
) => {
  try {
    return prisma.sessionTrack.create({
      data: {
        eventId,
        color,
        translations: {
          createMany: {
            data: translations,
          },
        },
      },
    });
  } catch (error) {
    console.error("Error creating session track:", error);
    throw new Error("Error creating session track");
  }
};

export const getSessionTrackById = async (id: string) => {
  return prisma.sessionTrack.findUnique({ where: { id } });
};

export const updateSessionTrack = async (
  id: string,
  data: Prisma.SessionTrackUpdateInput
) => {
  return prisma.sessionTrack.update({ where: { id }, data });
};

export const deleteSessionTrack = async (id: string) => {
  return prisma.sessionTrack.delete({ where: { id } });
};

export const listSessionTracks = async (options: {
  eventId?: string;
  search?: string;
  page?: number;
  limit?: number;
}) => {
  const { eventId, search, page = 1, limit = 10 } = options;
  const where: Prisma.SessionTrackWhereInput = {};
  if (eventId) {
    where.eventId = eventId;
  }
  if (search) {
    where.translations = { some: { name: { contains: search } } };
  }
  const [total, sessionTracks] = await prisma.$transaction(async (tx) =>
    Promise.all([
      tx.sessionTrack.count({ where }),
      tx.sessionTrack.findMany({
        where,
        skip: (page - 1) * limit,
        take: limit,
        include: {
          translations: true,
        },
      }),
    ])
  );
  const hasNextPage = (page - 1) * limit + limit < total;

  return {
    sessionTracks,
    pagination: {
      total,
      totalPages: Math.ceil(total / limit),
      currentPage: page,
      hasNextPage,
      hasPreviousPage: page > 1,
    },
  };
};
